import styled from '@mui/material/styles/styled';

export const Styled = {
  Wrapper: styled('div')<{ allowTyping?: boolean }>(({ allowTyping }) => ({
    display: allowTyping ? 'none' : 'block',
  })),
};
